import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EnvService } from "./env.service";
import { Subject, Observable } from "rxjs";
import { LocalStorageService } from "./storage.service";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: "root",
})
export class JwtService {
  private authUrl: string;
  jwtHelper: JwtHelperService = new JwtHelperService();
  constructor(
    private http: HttpClient,
    private env: EnvService,
    private store: LocalStorageService
  ) {
    this.authUrl = this.env.coreApi + "/User/Login";
  }

  getToken(): string | null {
    return this.store.get("access_token");
  }

  getDecodedToken(): any {
    const token = this.getToken();
    return token ? this.jwtHelper.decodeToken(token) : "";
  }

  // getRole(): string | null {
  //   // return "admin";
  //   // TODOROLE: uncomment when role comming in token
  //   const decoded = this.getDecodedToken();
  //   return decoded?.role || null;
  // }

  getRole(): string | null {
    const decoded = this.getDecodedToken();
    const authorities: string[] = decoded?.authorities || [];

    // Find the first authority that starts with "R_"
    const rawRole = authorities.find((a) => a.startsWith("R_"));
    if (!rawRole) {
      return null;
    }

    // Define your mapping
    const roleMap: Record<string, string> = {
      R_SUPERADMIN: "admin",
      R_ADMIN: "admin",
      R_USER: "user",
      R_CUSTOMER: "customer",
    };
    // Return the mapped value (or null if it’s an unexpected one)
    return roleMap[rawRole] ?? null;
  }

  isLoggedIn(): boolean {
    return !this.jwtHelper.isTokenExpired(this.getToken() || "");
  }

  // hasRole(roles: string[]): boolean {
  //   const role = this.getRole();
  //   return role !== null && roles.includes(role);
  // }

  hasRole(roles: string[]): boolean {
    // console.log(this.getRole(), "___________ROLE");
    return roles.includes(this.getRole() ?? "");
  }

  login(username: string, password: string): Observable<any> {
    const body = { username, password };
    return this.http.post<any>(this.authUrl, body);
  }

  logout() {
    this.store.remove("access_token");
  }

  public isTokenExpired() {
    return this.jwtHelper.isTokenExpired(localStorage.getItem("access_token"));
  }
}
